import React, { useEffect, useMemo, useState } from 'react'
import CustomModal from 'src/components/configuracion/components/customModal'
import { formatMoney } from 'src/utils/formatter'
import './NominaConciliationConflictModal.styles.scss'

/**
 * Shown when the user attempts to send to nomina a document that is already
 * bank-reconciled (meta.originalAmount > meta.remaining).
 *
 * It asks whether the amount being selected for nomina corresponds to the
 * already conciliated amount or not.
 */
const NominaConciliationConflictModal = ({ open, onClose, documents = [], onConfirm }) => {
  const initialMap = useMemo(() => {
    const m = {}
    for (const d of documents) m[d.documentId] = false
    return m
  }, [documents])

  const [decisions, setDecisions] = useState(initialMap)

  useEffect(() => {
    if (open) setDecisions(initialMap)
  }, [open, initialMap])

  const rows = documents || []

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Documento ya conciliado"
      classNameModal="nomina-conciliation-conflict-modal"
      classNameContent="nomina-conciliation-conflict-modal-content-wrapper"
      classNameTitle="nomina-conciliation-conflict-modal-title"
      size="tiny"
      confirmLabel="Continuar"
      onConfirm={() => onConfirm(decisions)}
      confirmDisabled={rows.length === 0}
      dimmer={{ style: { zIndex: 9999, backgroundColor: 'rgba(0,0,0,0.5)' } }}
      modalStyle={{
        maxWidth: '90%',
        minWidth: '50vw',
        maxHeight: '90vh',
        overflow: 'hidden',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
      }}
      content={
        <div className="nomina-conciliation-conflict-modal-content">
          <div className="nomina-conciliation-conflict-intro">
            Detectamos que uno o más documentos ya tienen un monto conciliado por banco.
            Para evitar inconsistencias, indica si el monto que vas a enviar a nómina corresponde a ese monto conciliado.
          </div>

          <div className="nomina-conciliation-conflict-table">
            <div className="nomina-conciliation-conflict-header">
              <div className="w-45">Documento</div>
              <div className="w-20 text-center">Conciliado</div>
              <div className="w-20 text-center">Seleccionado</div>
              <div className="w-15 text-center">¿Corresponde?</div>
            </div>

            <div className="nomina-conciliation-conflict-body">
              {rows.map((d) => (
                <div key={d.documentId} className="nomina-conciliation-conflict-row">
                  <div className="w-45">
                    <div className="nomina-conciliation-conflict-doc-title">
                      {d.title || d.summary || d.documentId}
                    </div>
                    {d.subtitle ? (
                      <div className="nomina-conciliation-conflict-doc-subtitle">{d.subtitle}</div>
                    ) : null}
                  </div>
                  <div className="w-20 text-center">$ {formatMoney(d.matchedAmount || 0)}</div>
                  <div className="w-20 text-center">$ {formatMoney(d.amountToSelect || 0)}</div>
                  <div className="w-15 text-center">
                    <label className="nomina-conciliation-conflict-checkbox-label">
                      <input
                        type="checkbox"
                        className="nomina-conciliation-conflict-checkbox"
                        checked={Boolean(decisions[d.documentId])}
                        onChange={(e) =>
                          setDecisions((prev) => ({ ...prev, [d.documentId]: e.target.checked }))
                        }
                      />
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    />
  )
}

export default NominaConciliationConflictModal

